module.exports = __webpack_public_path__ + "static/img/aepic-28-2.b573abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-28-2.jpg
// module id = Qq2u
// module chunks = 51